import "./NullTransition.css";
import { cssTransition } from "react-toastify";

export const NullTransition = cssTransition({
  enter: "toast-enter",
  exit: "toast-exit",
  duration: 0,
});
